import React, { useRef, useState } from 'react';
import './FileUpload.css';
import { toast, ToastContainer } from 'react-toastify';

const FileUpload = ({ isOpen, closeUpload, files, setFiles, fileProcessType, setFileProcessType }) => {
  const [errorMessage, setErrorMessage] = useState('');
  const fileInputRef = useRef();

  const checkFileType = (file) => {
    return file.type === 'application/pdf';
  };

  const checkFileCount = (newFiles) => {
    return files.length + newFiles.length <= 50;  // Maksimum 10 dosya
  };

  const checkTotalFileSize = (newFiles) => {
    const totalSize = newFiles.reduce((sum, file) => sum + file.size, 0);
    return (files.reduce((sum, file) => sum + file.size, 0) + totalSize) <= 104857600;  // 100MB
  };

  const handleFiles = (filesToAdd) => {
    let validFiles = [];
    let totalSize = 0;

    filesToAdd.forEach((file) => {
      if (checkFileType(file)) {
        validFiles.push(file);
        totalSize += file.size;
      } else {
        toast.error(`Dosya geçerli bir PDF değil.`);
      }
    });

    if (!checkFileCount(validFiles)) {
      toast.error('Toplamda sadece 10 dosya yükleyebilirsiniz.');
    } else if (!checkTotalFileSize(validFiles)) {
      toast.error('Toplam dosya boyutu 100MB\'yi geçemez.');
    } else {
      setFiles((prev) => [...prev, ...validFiles]);
      setErrorMessage('');
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const droppedFiles = Array.from(e.dataTransfer.files);
    handleFiles(droppedFiles);
  };

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    handleFiles(selectedFiles);
  };

  const handleAreaClick = () => {
    if (fileInputRef.current) fileInputRef.current.click();
  };

  const removeFile = (fileIndex) => {
    const updatedFiles = files.filter((_, index) => index !== fileIndex);
    setFiles(updatedFiles);
  };

  if (!isOpen) return null;

  return (
    <div className="file-upload-overlay" onClick={closeUpload}>
      <div className="file-upload-modal" onClick={(e) => e.stopPropagation()}>
        <h3 className="modal-title">Dosya Yükle</h3>

        {/* 1. Sürükle-Bırak / Tıklayarak Seçme Alanı */}
        <div
          className="file-drop-area"
          onDragOver={(e) => e.preventDefault()}
          onDrop={handleDrop}
          onClick={handleAreaClick}
        >
          <p>Dosyaları buraya sürükleyin veya tıklayıp seçin</p>
          <input
            type="file"
            multiple
            ref={fileInputRef}
            className="file-input"
            onChange={handleFileChange}
          />
        </div>

        {/* 2. Yüklenmiş / Seçilmiş Dosyaların Listesi */}
        <div className="file-list">
          {files.length > 0 ? (
            files.map((file, index) => (
              <div key={index} className="file-item">
                <button className="remove-btn" onClick={() => removeFile(index)}>X</button>
                <span className="file-name">{file.name}</span>
                <span className="file-size">{(file.size / 1024 / 1024).toFixed(2)} MB</span>
              </div>
            ))
          ) : (
            <p className="no-files">Henüz yüklenen dosya yok</p>
          )}
        </div>

        {/* 2.5. Arama Tercihi Dropdown'u */}
        <div className="file-process-type-row">
          <label htmlFor="fileProcessType" style={{ marginRight: 8, fontWeight: 500 }}>
            Dosya Ekleme Tercihi:
          </label>
          <select
            id="fileProcessType"
            value={fileProcessType}
            onChange={e => setFileProcessType(e.target.value)}
            className="file-process-type-select"
            style={{ padding: "4px 12px", borderRadius: 4 }}
          >
            <option value="only">Sadece dokümanlardan yararlan</option>
            <option value="include">Dokümanları geniş aramaya dahil et</option>
          </select>
        </div>

        {/* Hata mesajları */}
        {errorMessage && <div className="error-message">{errorMessage}</div>}

        {/* 3. Kapat Butonu */}
        <button onClick={closeUpload} className="close-btn">
          Dosya Yüklemeyi Bitir
        </button>
      </div>

      {/* ToastContainer */}
      <ToastContainer />
    </div>
  );
};

export default FileUpload;
